(() => {
  angular.module('app').controller('host.views.settings.index', SettingsController);

  SettingsController.$inject = [
    '$scope',
    'abp.services.app.hostSettings',
    'abp.services.app.sms',
    'abp.services.app.commonLookup',
    '$uibModal',
    'Abp.Configuration.Setting',
    'Hms.PaymentAccounts.PaymentAccount',
    'Hms.Collaterals.CollateralAndCreditLimitState',
    'moment',
  ];

  function SettingsController(
    $scope,
    hostSettingsSvc,
    smsSvc,
    commonLookupSvc,
    $modal,
    constsAbpConfig,
    constsPaymentAccount,
    enumCollateralAndCreditLimitState,
    moment
  ) {
    const vm = this;
    vm.constsAbpConfig = constsAbpConfig;
    vm.constsPaymentAccount = constsPaymentAccount;
    vm.enumCollateralAndCreditLimitState = enumCollateralAndCreditLimitState;
    vm.loading = 0;
    vm.testing = 0;
    vm.saving = 0;
    vm.midnightDuration = 0;
    vm.zendeskTestResult = null;

    // Snapshot of the Zendesk block as last loaded or saved. Test Connection validates saved
    // settings, so the button is blocked while the form differs from this -- otherwise ticking
    // "Authenticate with OAuth" and testing without saving would exercise the API token and
    // report success, which is the misleading result this screen exists to avoid.
    vm.savedZendesk = null;
    vm.settings = null;
    vm.clinicLanguages = [];
    vm.smsProviders = [];
    vm.pharmacySaleSettingsList = [{}];

    vm.hasSobEnhancement = abp.setting.getBoolean('Hms.Feature.SobEnhancement');
    vm.hasRegionalSystemSupport = abp.setting.getBoolean('Hms.Feature.RegionalSystemSupport');
    vm.hasSingaporeInvoiceGeneration = abp.setting.getBoolean(
      'Hms.Feature.SingaporeInvoiceGeneration'
    );
    vm.hasGpDashboardEnhancement = abp.setting.getBoolean('Hms.Feature.GPDashboardEnhancement');
    vm.hasInsurerModule = abp.setting.getBoolean('Hms.Feature.InsuranceModule');
    vm.hasSmsService = abp.setting.getBoolean('Hms.Feature.SmsService');
    vm.hasMailingModule = abp.auth.isGranted('HealthMetrics.Mailing');

    vm.saveAll = saveAll;
    vm.getLanguage = getLanguage;
    vm.calculateDuration = calculateDuration;
    vm.testZendeskConnection = testZendeskConnection;
    vm.zendeskSettingsUnsaved = zendeskSettingsUnsaved;
    vm.zendeskResultMessage = zendeskResultMessage;
    vm.openOneSignalNotificationCategoryModal = openOneSignalNotificationCategoryModal;
    vm.addNewPharmacySale = addNewPharmacySale;
    vm.deleteLatestPharmacySale = deleteLatestPharmacySale;
    vm.getEligibleCountries = getEligibleCountries;
    vm.removeSelectedCountry = removeSelectedCountry;
    vm.getTeleconsultServices = getTeleconsultServices;
    vm.getPharmacySalesSettings = getPharmacySalesSettings;

    init();

    function init() {
      getAllSettings();

      if (!vm.hasSmsService) {
        getSmsProviders();
      }

      getEligibleCountries();
      getTeleconsultServices();
      getPharmacySalesSettings();
      getBanks();
    }

    function getAllSettings() {
      vm.loading += 1;
      hostSettingsSvc
        .getAllSettings()
        .success((data) => {
          data.treatmentManagement.midnightStartTime = moment(
            data.treatmentManagement.midnightStartTime
          ).toDate();
          data.treatmentManagement.midnightEndTime = moment(
            data.treatmentManagement.midnightEndTime
          ).toDate();
          vm.settings = data;
          vm.savedZendesk = angular.copy(data.integration.zendesk);
          vm.calculateDuration();
        })
        .finally(() => {
          vm.preventDisableSobEnhancement = vm.settings && vm.settings.feature.sobEnhancement;
          vm.preventDisableTxtFileSupport = vm.settings && vm.settings.feature.txtFileSupport;
          vm.preventDisableRegionalSystemSupport =
            vm.settings && vm.settings.feature.regionalSystemSupport;
          vm.preventDisableHealthScreeningModule =
            vm.settings && vm.settings.feature.healthScreeningModule;
          vm.preventDisableExcludedServiceTypesEnhancement =
            vm.settings && vm.settings.feature.excludedServiceTypesEnhancement;
          vm.preventDisableRegionalReimbursementSupport =
            vm.settings && vm.settings.feature.regionalReimbursementSupport;
          vm.preventDisableNYearBenefitsEnhancement =
            vm.settings && vm.settings.feature.nYearBenefitsEnhancement;
          vm.preventDisableHospitalisationWaitingPeriodEnhancement =
            vm.settings && vm.settings.feature.hospitalisationWaitingPeriodEnhancement;
          vm.preventDisableIndonesiaAndThailandRegionalExpansion =
            vm.settings && vm.settings.feature.indonesiaAndThailandRegionalExpansion;
          vm.preventDisableRegionalExpansionForInpatient =
            vm.settings && vm.settings.feature.regionalExpansionForInpatient;
          vm.loading -= 1;
        });
    }

    function saveAll() {
      vm.settings.pharmacySales = vm.pharmacySaleSettingsList;

      if (validateSettings() && $scope.settings.$valid) {
        vm.saving += 1;
        hostSettingsSvc
          .updateAllSettings(vm.settings)
          .success(() => {
            abp.notify.info(App.localize('SuccessfullySaved'));

            // Refreshed on success only. Doing it in .finally would re-enable Test Connection
            // after a failed save, against settings the server never received.
            vm.savedZendesk = angular.copy(vm.settings.integration.zendesk);

            // A result describes the configuration it was run against, so saving invalidates it.
            // Without this, unticking OAuth and saving brings the old "OAuth connection failed"
            // banner back beside an API-token configuration that has never been tested.
            vm.zendeskTestResult = null;
            vm.preventDisableSobEnhancement = vm.settings.feature.sobEnhancement;
            vm.preventDisableTxtFileSupport = vm.settings.feature.txtFileSupport;
            vm.preventDisableRegionalReimbursementSupport =
              vm.settings.feature.regionalReimbursementSupport;

            // Prevent disabling regional expansion for inpatient after enabled.

            vm.preventDisableRegionalExpansionForInpatient =
              vm.settings.feature.regionalExpansionForInpatient;

            getPharmacySalesSettings();
          })
          .finally(() => {
            vm.saving -= 1;
          });
      } else {
        abp.notify.error(App.localize('FailedToSave'));
      }
    }

    function getLanguage(code) {
      return App.localize(code);
    }

    function calculateDuration() {
      vm.midnightDuration = '-';
      if (vm.settings && vm.settings.treatmentManagement) {
        const endTime = moment(vm.settings.treatmentManagement.midnightEndTime);
        const startTime = moment(vm.settings.treatmentManagement.midnightStartTime);
        if (endTime.isValid() && startTime.isValid()) {
          let hrs = (endTime.valueOf() - startTime.valueOf()) / 1000 / 60 / 60;
          if (hrs <= 0) hrs += 24;
          vm.midnightDuration = hrs;
        }
      }
    }

    // Mirrors Hms.Zendesk.ZendeskAuthMode. Newtonsoft serialises the enum as its numeric value,
    // so the names live here rather than as bare numbers in the view.
    const zendeskAuthMode = { apiToken: 0, oAuth: 1 };

    function testZendeskConnection() {
      vm.testing += 1;
      hostSettingsSvc
        .testZendeskApiConnection()
        .success((result) => {
          vm.zendeskTestResult = result;
        })
        .finally(() => {
          vm.testing -= 1;
        });
    }

    // The server reports which mode it actually used. Deriving it from the checkbox would read
    // the form's unsaved state, which can disagree with what the request did.
    function zendeskResultMessage() {
      if (!vm.zendeskTestResult) return '';

      const isOAuth = vm.zendeskTestResult.authMode === zendeskAuthMode.oAuth;

      if (vm.zendeskTestResult.isSuccess) {
        return App.localize(
          isOAuth ? 'ZendeskConnectionSuccessOAuth' : 'ZendeskConnectionSuccessApiToken'
        );
      }

      return App.localize(
        isOAuth ? 'ZendeskConnectionFailedOAuth' : 'ZendeskConnectionFailedApiToken',
        vm.zendeskTestResult.errorMessage
      );
    }

    function zendeskSettingsUnsaved() {
      // Explicit null check rather than leaning on angular.equals: it returns true for
      // (null, null), so before the first load the button would read as saved and enable itself.
      // Only the panel-wide busy overlay hides that today, which is not a guarantee to rely on.
      if (!vm.settings || !vm.savedZendesk) return true;

      return !angular.equals(vm.savedZendesk, vm.settings.integration.zendesk);
    }

    function validateSettings() {
      if (Number.isNaN(vm.settings.general.minimumAppBuildNumberSupported)) {
        abp.notify.error('Minimum app build number support is not a number');
        return false;
      }

      if (Number.isNaN(vm.settings.general.minimumPwaBuildNumberSupported)) {
        abp.notify.error('Minimum PWA build number support is not a number');
        return false;
      }

      return true;
    }

    function getBanks() {
      vm.loading += 1;
      commonLookupSvc
        .getBanks()
        .success((data) => {
          vm.banks = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function openOneSignalNotificationCategoryModal() {
      const modal = $modal.open({
        templateUrl: require('./oneSignalNotificationCategory/oneSignalNotificationCategory.modal.html'),
        controller:
          'host.views.settings.oneSignalNotificationCategory.oneSignalNotificationCategory.modal as vm',
        backdrop: 'static',
        resolve: {
          categories: vm.categories,
        },
      });

      modal.result.then(() => {});
    }

    function getSmsProviders() {
      vm.loading += 1;
      smsSvc
        .getSmsProviders()
        .success((data) => {
          vm.smsProviders = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function addNewPharmacySale() {
      removeSelectedCountry();
      vm.pharmacySaleSettingsList.push({});
    }

    function deleteLatestPharmacySale() {
      vm.pharmacySaleSettingsList.splice(vm.pharmacySaleSettingsList.length - 1, 1);
      removeSelectedCountry();
    }

    function getEligibleCountries() {
      vm.loading += 1;
      commonLookupSvc
        .getEligibleCountries()
        .success((data) => {
          vm.countries = data;
          vm.filteredCountries = vm.countries;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getTeleconsultServices() {
      vm.loading += 1;
      commonLookupSvc
        .getTeleconsultServices()
        .success((data) => {
          vm.teleconsultServices = data;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function getPharmacySalesSettings() {
      vm.loading += 1;
      commonLookupSvc
        .getPharmacySalesSettings()
        .success((data) => {
          vm.pharmacySaleSettingsList = data;
          vm.filteredCountries = vm.countries;

          setTimeout(() => {
            removeSelectedCountry();
          }, 500);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function removeSelectedCountry() {
      const selectedCountries = _.map(vm.pharmacySaleSettingsList, 'countryCode');
      vm.filteredCountries = _.filter(
        vm.countries,
        (country) => !_.includes(selectedCountries, country.code)
      );
    }
  }
})();
